import { Command } from 'commander';
import chalk from 'chalk';
import { createImageGenCommand } from './gen.js';
import { createImageListCommand } from './list.js';
import { createImageInfoCommand } from './info.js';
import { createImageDeleteCommand } from './delete.js';

function showImageHelp(): void {
    console.log(chalk.bold.cyan('🎨 jai1 image') + chalk.dim(' - Image generation commands'));
    console.log();
    console.log(chalk.yellow('⚠️  Coming Soon - Tính năng đang phát triển'));
    console.log();
    console.log(chalk.bold('Các lệnh:'));
    console.log(`  ${chalk.cyan('gen')}       Tạo ảnh từ prompt`);
    console.log(`  ${chalk.cyan('list')}      Liệt kê các ảnh đã tạo`);
    console.log(`  ${chalk.cyan('info')}      Xem thông tin ảnh`);
    console.log(`  ${chalk.cyan('delete')}    Xóa ảnh`);
    console.log();
    console.log(chalk.bold('Ví dụ:'));
    console.log(chalk.dim('  $ jai1 image gen "a cute cat"'));
    console.log(chalk.dim('  $ jai1 image list'));
    console.log(chalk.dim('  $ jai1 image info <image-id>'));
    console.log();
    console.log(chalk.dim('Chạy "jai1 image <lệnh> --help" để xem chi tiết'));
}

export function createImageCommand(): Command {
    const cmd = new Command('image')
        .description('Image generation commands (Coming Soon)')
        .action(() => {
            showImageHelp();
        });

    cmd.addCommand(createImageGenCommand());
    cmd.addCommand(createImageListCommand());
    cmd.addCommand(createImageInfoCommand());
    cmd.addCommand(createImageDeleteCommand());

    return cmd;
}
